(function ($) {
  $(window).on("load", function () {
    $module = $(".posts-module");

    $module.find(".post-cards.slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: $module.find(".slick-prev"),
      nextArrow: $module.find(".slick-next"),
      infinite: false,
      speed: 500,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $(".post-cards.slider .slick-dots button").attr("tabindex", 0);
  });
})(jQuery);
